export function safeStartsWith(str: string, prefix: string) {
    return typeof str === typeof '' && str.toLowerCase().indexOf(prefix.toLowerCase()) === 0;
}

export function safeEndsWith(str: string, suffix: string) {
    return typeof str === typeof '' && str.toLowerCase().indexOf(suffix.toLowerCase()) === str.length - suffix.length;
}
